export default {
  slug: "jetbrains-ides",
  code: "IDEs",
  label: "JetBrains IDEs",
  logoFamily: "jb",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#F001A0",
};
